module.exports = ".container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.user-table {\r\n    overflow: auto;\r\n    min-width: 700px;\r\n}\r\n\r\n.mat-column-username,\r\n.mat-column-fullName {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    min-width: 170px;\r\n}\r\n\r\n.mat-column-isWebAdmin,\r\n.mat-column-isActive,\r\n.mat-column-isLocked,\r\n.mat-column-actions {\r\n    min-width: 60px;\r\n    max-width: 100px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-list/user-list.component.css
// module id = 625
// module chunks = 1